import styled from 'styled-components';
import { getPublicPath } from 'utils/paths';
import {
  color,
  fontFamily,
  fontSize,
  fontWeight,
  radius,
  screen,
  spacing,
} from '../../../theme';

export const StyledWhereOffice = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${spacing('xl')} ${spacing('lg')};
  background-color: ${color('midnight_900')};
  border-radius: ${radius('lg')};
  color: ${color('text_default_inverse')};
  background-image: ${() =>
    // eslint-disable-next-line no-undef
    `url('${getPublicPath('/images/jobOffer/officeBg.png')}')`};
  background-size: 250px 250px;
  background-repeat: repeat;
  background-blend-mode: screen;
  margin-bottom: ${spacing('xl')};

  @media (min-width: ${screen('md')}) {
    margin-bottom: 0;
  }
`;

export const StyledWhereOfficeLogo = styled.img`
  display: block;
  height: ${spacing('xl4')};
  margin-bottom: ${spacing('sm')};
`;

export const StyledWhereOfficeTitle = styled.h4`
  font-family: ${fontFamily('serif')};
  font-size: ${fontSize('lg')};
  font-weight: ${fontWeight('bold')};
  margin: 0;
`;

export const StyledWhereOfficeAddress = styled.address`
  font-style: normal;
  line-height: 1.5;
  margin-top: ${spacing('md')};
  margin-bottom: ${spacing('md')};
  padding-top: ${spacing('md')};
  padding-bottom: ${spacing('md')};
  position: relative;

  &::before,
  &::after {
    content: '';
    display: block;
    height: 1px;
    width: ${spacing('xl4')};
    background-color: ${color('midnight_700')};
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  &::before {
    top: 0;
  }

  &::after {
    bottom: 0;
  }
`;

export const StyledWhereOfficeLink = styled.a`
  color: ${color('link_inverse')};
  font-size: ${fontSize('sm')};
  display: inline-flex;
  align-items: center;

  &:hover {
    color: ${color('link_inverse_hover')};
  }
  &:focus,
  &:active {
    color: ${color('link_inverse_active')};
  }

  svg {
    height: ${spacing('md')};
    margin-right: ${spacing('xs')};

    .fa-secondary {
      opacity: 1;
    }
    .fa-primary {
      color: ${color('navy_500')};
    }
  }
`;
